export const isPublicRoute = () => {
  return window.location.pathname.includes('/p/');
};
